import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import SuperAdmin from "@/pages/SuperAdmin";
import ShopAdmin from "@/pages/ShopAdmin";
import Catalog from "@/pages/Catalog";
import SareeDetail from "@/pages/SareeDetail";
import Cart from "@/pages/Cart";
import Favorites from "@/pages/Favorites";
import Mirror from "@/pages/Mirror";
import PageNav from "@/components/app/PageNav";

function Protected({ role, children }) {
    const { user, ready } = useAuth();
    if (!ready) return <div className="min-h-screen grid place-items-center text-brand-muted">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (role && user.role !== role) {
        if (user.role === "super_admin") return <Navigate to="/super-admin" replace />;
        if (user.role === "shop_owner") return <Navigate to="/admin" replace />;
        return <Navigate to="/" replace />;
    }
    return children;
}

function App() {
    useEffect(() => { document.title = "Vastra AI — Drape your story"; }, []);
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <PageNav />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/super-admin" element={<Protected role="super_admin"><SuperAdmin /></Protected>} />
                        <Route path="/admin" element={<Protected role="shop_owner"><ShopAdmin /></Protected>} />
                        <Route path="/shop/:slug" element={<Catalog />} />
                        <Route path="/shop/:slug/saree/:id" element={<SareeDetail />} />
                        <Route path="/shop/:slug/cart" element={<Cart />} />
                        <Route path="/shop/:slug/favorites" element={<Favorites />} />
                        <Route path="/mirror/:slug" element={<Mirror />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-center" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
